import { DatePipe, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from '@environments/environment';
import { RestrictedNavigationService } from '@services/restricted-navigation.service';

@Component({
  selector: 'app-treatmyuti-layout',
  templateUrl: './treatmyuti-layout.component.html',
  styleUrls: ['./treatmyuti-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, DatePipe, NgOptimizedImage],
})
export class TreatmyutiLayoutComponent implements OnInit {
  public restrictedNavigation: boolean = false;
  public today: Date = new Date();

  private restrictedNavigationService = inject(RestrictedNavigationService);

  /**
   * Returns the brand's customer service phone number.
   */
  public get phoneNumber(): string {
    return environment.phone;
  }

  public ngOnInit(): void {
    this.restrictedNavigationService.restrictedNavigationObserver.subscribe((r) => (this.restrictedNavigation = r));
  }
}
